import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=bbadc2de&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbadc2de')) {
      api.createRecord('bbadc2de', component.options)
    } else {
      api.reload('bbadc2de', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=bbadc2de&", function () {
      api.rerender('bbadc2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8yK2fSSWlyC8y/JS/pricehelp.vue"
export default component.exports